import { Flex, SystemStyleObject, Text } from '@chakra-ui/react'
import React from 'react'
import { useDateTimeCellStyles } from '~/pages/Calls/componentStyles/CallsListItem.style'

interface DateTimeCellProps {
  date: string
  time: string
  columnStyles: SystemStyleObject
}
export const DateTimeCell = ({
  columnStyles,
  date,
  time,
}: DateTimeCellProps) => {
  const styles = useDateTimeCellStyles()
  // const columnStyles = useTableStyles()[CallTableColumn.DateTime]
  return (
    <Flex sx={{ ...columnStyles, ...styles.container }}>
      <Text sx={styles.timeText}>{time}</Text>
      <Flex sx={styles.timeWrapper} alignItems="center" gap="0.25rem">
        <Text sx={styles.dateText}>{date}</Text>
      </Flex>
    </Flex>
  )
}
